// extracted by mini-css-extract-plugin
module.exports = {"QuestionAnswer":"QuestionAnswer--25q2L","QuestionAnswer-question":"QuestionAnswer-question--3rFcK","QuestionAnswer-answer":"QuestionAnswer-answer--3ZY3K"};